export default __webpack_public_path__ + "static/media/instagram.bad3e563.svg";